import defaultImage from '@assets/img/svg/wake-creators.svg'
import './lp-tag.component.scoped.scss'

interface Props {
  id?: string
  name?: string
  icon?: string
  moreWhiteLabels?: number
}

export default ({ id, name, icon, moreWhiteLabels = null }: Props) => {
  return moreWhiteLabels ? (
    <div className="lp-item">+ {moreWhiteLabels}</div>
  ) : (
    <div key={id} className="lp-item">
      <figure className="lp-icon" title={name}>
        <img
          src={icon}
          alt={name}
          onError={({ currentTarget }) => {
            currentTarget.src = defaultImage
          }}
        />
      </figure>
      <span className="lp-name">{name.length > 14 ? name.match(/.{1,14}/g)[0] : name}</span>
    </div>
  )
}
